import React from "react";
import { Helmet } from "react-helmet";
import Link from "gatsby-link";
import { X, Download, Mail, HelpCircle, Menu as Burger } from "react-feather";
import { slide as Menu } from "react-burger-menu";
import {
  LinkedinShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinIcon
} from "react-share";
import Header from "../components/layout/Header";
import { ModalProvider } from "../components/ModalContext";
import ModalRoot from "../components/ModalRoot";
import diamondIcon from "./img/menu-icon-diamond.svg";
import faviconico from "./img/favicon.ico";
import faviconpng from "./img/favicon.png";
import "../styles/style.scss";

const debugStyles = {
  display: "none",
  position: "absolute",
  bottom: 0,
  left: 0,
  fontSize: 18,
  zIndex: 999,
  padding: 40
};

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuOpen: false };
  }
  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }
  closeMenu() {
    this.setState({ menuOpen: false });
  }

  handleTwitterClick = () => {
    if (typeof ga === "function") {
      ga("send", "event", {
        eventCategory: "Social",
        eventAction: "click",
        eventLabel: "Twitter Share"
      });
    }
  };

  handleLinkedinClick = () => {
    if (typeof ga === "function") {
      ga("send", "event", {
        eventCategory: "Social",
        eventAction: "click",
        eventLabel: "LinkedIn Share"
      });
    }
  };

  render() {
    return (
      <ModalProvider value={this.state.value}>
        <div id="outer-container" className="wrapper">
          <Helmet>
            <link rel="shortcut icon" type="image/x-icon" href={faviconico} />
            <link
              rel="icon"
              type="image/png"
              href={faviconpng}
              sizes="196x196"
            />
            <title>{"Jakten på den oslipade diamanten"}</title>
            <meta
              name="description"
              content="Upptäck arbetsmarknadens vanligaste floskler, lär dig andra uttryck och stick ut i mängden!"
            />
            <meta itemprop="name" content="Jakten på den oslipade diamanten" />
            <meta
              itemprop="description"
              content="Upptäck arbetsmarknadens vanligaste floskler, lär dig andra uttryck och stick ut i mängden!"
            />
            <meta name="theme-color" content="#00005A" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta
              name="twitter:title"
              content="Jakten på den oslipade diamanten"
            />
            <meta
              name="twitter:description"
              content="Upptäck arbetsmarknadens vanligaste floskler. Lär dig andra uttryck och stick ut i mängden!"
            />
            <meta
              name="twitter:image"
              content="https://jakten.arbetsgivare.nu/images/Jakten_Banner_1200x628.png"
            />
            <meta property="og:url" content="https://jakten.arbetsgivare.nu/" />
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content="Jakten på den oslipade diamanten"
            />
            <meta
              property="og:description"
              content="Upptäck arbetsmarknadens vanligaste floskler, lär dig andra uttryck och stick ut i mängden!"
            />
            <meta
              property="og:image"
              content={
                "https://jakten.arbetsgivare.nu/images/Jakten_Banner_1200x628.png"
              }
            />
            <meta
              property="og:site_name"
              content="Jakten på den oslipade diamanten"
            />
            <meta property="og:locale" content="sv_SE" />
          </Helmet>
          <Header />
          {this.props.children()}
          <pre style={debugStyles}>
            <Link to="/flexibel">Flexibel</Link>
            <br />
            <Link to="/flexibel/02">Flexibel 02</Link>
            <hr />
            <Link to="/lagspelare">Lagspelare</Link>
            <br />
            <Link to="/lagspelare/02">Lagspelare 02</Link>
            <hr />
            <Link to="/driven">Driven</Link>
            <br />
            <Link to="/driven/02">Driven 02</Link>
            <hr />
            <Link to="/ninja">Ninja</Link>
            <br />
            <Link to="/ninja/02">Ninja 02</Link>
            <hr />
            <Link to="/about">Varför har vi...</Link>
            <br />
            <Link to="/resources">Ladda ned</Link>
            <br />
            <Link to="/">Hem</Link>
            <hr />
            <Link to="/start">Start</Link>
            <br />
            <Link to="/A">A</Link>
            <br />
            <Link to="/B">B</Link>
            <br />
            <Link to="/C">C</Link>
            <br />
            <Link to="/D">D</Link>
            <br />
            <Link to="/completed">Storgrattis</Link>
          </pre>
        </div>
        <ModalRoot />
      </ModalProvider>
    );
  }
}
export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js